import { render, staticRenderFns } from "./WO23Collection.vue?vue&type=template&id=0d67a8ba&scoped=true&"
import script from "./WO23Collection.vue?vue&type=script&lang=js&"
export * from "./WO23Collection.vue?vue&type=script&lang=js&"
import style0 from "./WO23Collection.vue?vue&type=style&index=0&id=0d67a8ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67a8ba",
  null
  
)

export default component.exports